export const SEMESTER = '/semester/'
export const SEMESTER_ALL = `${SEMESTER}all`
